import { useTranslation } from 'react-i18next';
import type { ItemHealth } from '@/common/api/types/dashboard/health';
import type { ItemStatus } from '@/common/api/types/itemStatus';
import { DependencyIndicator } from '@/features/item-panel/components/tabs/dependencies/DependencyIndicator';
import { resolveSuccessorImpactState } from '@/features/item-panel/components/tabs/dependencies/lib/edgeImpact';
import type { DependencyRow } from '@/features/item-panel/components/tabs/dependencies/lib/types';

export const DependencySuccessorCell = ({
  row,
  currentItemId,
  currentItemStatusId,
  currentItemHealth,
  healthByItemId,
  dependencyRulesV2,
  itemStatuses,
  anchorDate,
}: {
  row: DependencyRow;
  currentItemId: number;
  currentItemStatusId: number | null | undefined;
  currentItemHealth: ItemHealth | undefined;
  healthByItemId: Map<number, ItemHealth | undefined>;
  dependencyRulesV2: boolean;
  itemStatuses: ItemStatus[];
  anchorDate: string | null | undefined;
}) => {
  const { t } = useTranslation();
  const state = resolveSuccessorImpactState(dependencyRulesV2, {
    row,
    currentItemId,
    currentItemStatusId,
    currentItemHealth,
    healthByItemId,
    itemStatuses,
    anchorFinishDate: anchorDate,
  });

  if (state === 'error' || state === 'warning') {
    return (
      <DependencyIndicator
        state={state}
        label={
          state === 'error'
            ? t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.blockingBadge)
            : t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.atRiskBlockingBadge)
        }
        testId="successor-alert-badge"
      />
    );
  }

  if (state === 'neutral') {
    return (
      <DependencyIndicator
        state="neutral"
        label={t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.noDatesBadge)}
        testId="successor-no-dates-badge"
      />
    );
  }

  return <DependencyIndicator state="none" />;
};
